import { getEnvVariables } from './getEnvVariables';

export const ENV = getEnvVariables();
